import {formTransformer} from '../formTransformer';

export const profileToFormTransformer = profile => {
    if (!profile) {
        return null;
    }

    return {...formTransformer(profile, ['club', 'location'])}
}
